import { useContext } from "react";
import { TumanContext } from "./TumanContext";

export default function useTuman() {
  return useContext(TumanContext);
}
